// App.js

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import Navbar from "./components/Navbar.js";
import ScrollToTop from "./components/ScrollToTop.js";
import HomePage from "./pages/HomePage";
import CytoscapeGraph from "./components/CytoscapeGraph";
import DAG from "./components/DAG";
import UWG from "./components/UWG.js";
import DWG from "./components/DWG.js";
import FlowGraph from "./components/FlowGraph.js";
import About from "./components/About.js";
import ContactUs from "./components/ContactUs.js";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route
            path="/algorithm/bfs"
            element={<CytoscapeGraph algorithmType="bfs" />}
          />
          <Route
            path="/algorithm/dfs"
            element={<CytoscapeGraph algorithmType="dfs" />}
          />
          <Route
            path="/algorithm/topologicalSort"
            element={<DAG algorithmType="topologicalSort" />}
          />
          <Route path="/algorithm/scc" element={<DAG algorithmType="scc" />} />
          <Route
            path="/algorithm/kruskals"
            element={<UWG algorithmType="kruskals" />}
          />
          <Route
            path="/algorithm/prims"
            element={<UWG algorithmType="prims" />}
          />
          <Route
            path="/algorithm/dijkstra"
            element={<DWG algorithmType="dijkstra" />}
          />
          <Route path="/algorithm/dag" element={<DWG algorithmType="dags" />} />
          <Route
            path="/algorithm/bellmanFord"
            element={<DWG algorithmType="bellmanFord" />}
          />
          <Route
            path="/algorithm/edmonKarps"
            element={<FlowGraph algorithmType="edmonKarps" />}
          />
          <Route
            path="/algorithm/fordfulkerson"
            element={<FlowGraph algorithmType="fordfulkerson" />}
          />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
